module.exports = __webpack_public_path__ + "static/media/logoFooter.1654f7ff.png";